import React from 'react';
import { Link } from 'react-router-dom';
// import { Icon } from 'antd';
import WorkHome from './workHome';
import Nav from '../base_layout/Header/Nav';
import './pages.css';
import './logo.css';
import sticker from '../../assets/stickers-01.png'
import branding from '../../assets/branding-01.png'
import illustrate from '../../assets/illustration-01.png'
import webmosys from '../../assets/webmobilesys-01.png'
import photog from '../../assets/photography-01.png'
import layout from '../../assets/layout-01.png'

// import red from './splatter-red.svg';
// import green from './splatter-green.svg';

// var services = [
//     {
//         "name": "Branding",
//         "desc": "corporate identity",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542870688/rtds_work/RTDS%20Services/RTDS_ASS-06.png"
//     },
//     {
//         "name": "Graphic Design",
//         "desc": "design layout",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542984284/rtds_work/RTDS%20Services/RTDS_ASS2-08.png"
//     },
//     {
//         "name": "Photography",
//         "desc": "products, events and more",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542870689/rtds_work/RTDS%20Services/RTDS_ASS-11.png"
//     },
//     {
//         "name": "Stickers",
//         "desc": "customized, die-cut stickers, packaging labels and more",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542870689/rtds_work/RTDS%20Services/RTDS_ASS-04.png"
//     },
//     {
//         "name": "Prints",
//         "desc": "stickers, invitations, calling cards",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542870689/rtds_work/RTDS%20Services/RTDS_ASS-10.png"
//     },
//     {
//         "name": "Web Design",
//         "desc": "responsive web designs, ecommerce, CMS",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542984284/rtds_work/RTDS%20Services/RTDS_ASS2-09.png"
//     },
//     {
//         "name": "Digital Marketing",
//         "desc": "marketing using facebook, twitter, and instagram",
//         "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542870688/rtds_work/RTDS%20Services/RTDS_ASS-02.png"
//     }
// ];

class LandingPage extends React.Component {
    state = {
        scrolled: false
    }

    componentDidMount () {
        window.addEventListener('scroll', () => {
            const isTop = window.scrollY < 100;
            if (!isTop ) {
                this.setState({ scrolled: true })
            } else {
                this.setState({ scrolled: false })
            }
        })
    }

    // componentWillUnmount () {
    //     window.removeEventListener('scroll')
    // }

    handleScrollDown() {
        if (window.pageYOffset === 0 && window.screen.width <= 500) {
            // console.log('small', window.screen.width)
            window.scrollTo(0,600)
        } else {
            // console.log('big', window.screen.width)
            window.scrollTo(0,800)
        }
    }

    render() {
        const { scrolled } = this.state
        return(
            <div className="">
                <div className='bg-container'>
                    <div className='header'>
                        <Nav scrolled={scrolled} />
                        {/* <div className={!scrolled ? 'circle' : 'scrolled-circle'}> */}
                            {/* <div className={!scrolled ? 'content' : 'scrolled-content'}>
                                <h1 className={!scrolled ? '' : 'scrolled-h1'}>Redtomato</h1>
                                <p className={!scrolled ? '' : 'scrolled-p'}>Design Studio</p>
                            </div> */}
                        {/* </div> */}
                        {/* <img className={!scrolled ? 'splatter-red' : 'scrolled-splatter-red'} src={red} /> */}
                        {/* <img className={!scrolled ? 'splatter-green' : 'scrolled-splatter-green'} src={green} /> */}
                        {/* <span className='discover-btn bounce' onClick={this.handleScrollDown}>
                            <Icon type="down-circle" theme="twoTone" className='arrow-icon'/>
                        </span> */}
                    </div>
                </div>
                <div className="landing-page">
                    <div className="slogan">
                        <span>Spice up your ideas!</span>
                        {/* <Carousel autoplay fade>
                            <span>Spice up your ideas!</span>
                            <span>Have your own customized branding!</span>
                            <span>Have your own website!</span>
                            <span>Any ideas in you mind!</span>
                        </Carousel> */}
                        
                        <p><Link to='/process' className='explore'>Find out how</Link></p>
                    </div>

                    <div className="services-container" style={{backgroundColor: 'none'}}>
                        <h1>What We Do</h1>
                        
                        <div className="">
                            <WorkHome />
                            <br/><br/>
                            <h3 style={{textAlign:'center', textDecoration:'underline', fontWeight: '1000', fontSize: '25px'}}><Link to="/work">Explore our work</Link></h3>
                        </div>
                    </div>
                    <div className="services-container" style={{backgroundColor: 'whitesmoke'}}>
                        <div className="service-features-container">
                            <div className="service-feature">
                                <img src='https://res.cloudinary.com/doddfudab/image/upload/v1540407248/rtds_work/Invitations/Jessa18thInvi-Mockup.jpg' alt="furfamily" className='service-feature-img'/>    
                            </div>
                            <div className="service-feature">
                                <h4>Jessa Turns 18</h4>
                                {/* <div className="service-txt">Keep your furbabies closer and have a portrait with them. We illustrate you and furbabies in one photo!</div> */}
                                <div className="service-txt">This event is one of the important events that our clients will truly treasure. It's their daughter's 18th birthday and they want to give her the best birthday she will ever have. What is a party without its guests? Redtomato Design Studio made sure to provide them with the beautiful looking invitation letters that are to be handed out.</div>
                                <div className="services-done">
                                    <img src={layout} alt="" className="feature-icon"/>
                                </div>
                                <Link to="/work/jessa18"><p>See Project</p></Link>
                            </div>
                        </div>
                    </div>
                    <div className="services-container" style={{backgroundColor: 'whitesmoke'}}>
                        <div className="service-features-container-r">
                            <div className="service-feature">
                                <h4>Eats in the West</h4>
                                <div className="service-txt">Eats in the West offers great and affordable meals from breakfast till dinner, even at your snack time! Designing them their menu layout, illustrating their
                                brand logo, and providing them their own Purchasing Order System.</div>
                                <div className="services-done">
                                    <img src={branding} alt="" className="feature-icon"/>
                                    <img src={layout} alt="" className="feature-icon"/>
                                    <img src={webmosys} alt="" className="feature-icon"/>
                                </div>
                                <Link to="/work/eatsinthewest"><p>See Project</p></Link>
                            </div>
                            <div className="service-feature">
                                <img src='https://res.cloudinary.com/doddfudab/image/upload/v1542887168/rtds_work/Eats%20in%20the%20West/Poster-Frame-PSD-MockUp.jpg' alt="eats in the west" className='service-feature-img'/>    
                            </div>
                        </div>
                    </div>
                    <div className="services-container" style={{backgroundColor: 'none'}}>
                        <h1>Clients</h1>
                        <div className="clients-container">
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570303/rtds_work/Clients/clients-05.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570303/rtds_work/Clients/clients-08.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570303/rtds_work/Clients/clients-06.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570303/rtds_work/Clients/clients-07.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-10.png" alt="" className="client-img"/>
                            
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-09.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-12.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-15.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-11.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570304/rtds_work/Clients/clients-13.png" alt="" className="client-img"/>
                            
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570305/rtds_work/Clients/clients-14.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570305/rtds_work/Clients/clients-17.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570305/rtds_work/Clients/clients-18.png" alt="" className="client-img"/>

                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570305/rtds_work/Clients/clients-20.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570305/rtds_work/Clients/clients-03.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570306/rtds_work/Clients/clients-04.png" alt="" className="client-img"/>
                            <img src="https://res.cloudinary.com/doddfudab/image/upload/v1555570308/rtds_work/Clients/clients-19.png" alt="" className="client-img"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/pages/LandingPage.js